import loadScript from '@/helper/loadscript';
import { getOpenid, clearOpenid } from './openid-manger';
import { loginByOppoOid } from '@/apis/base';
import parse from 'url-parse';
import Cookies from 'js-cookie';

// 与oppo 商量好的登录方式
export const toOppoLogin = async function (resolvedNextRoute) {
  let oppoHost = 'https://www.opposhop.cn/recycle';
  let jsUrl = 'https://id.oppo.com/resources/js/oppo.login.js';
  // 测试环境才会注入 该cookie
  if (Cookies.get('hsb_test_env') || process.env.NODE_ENV !== 'production') {
    oppoHost = 'https://test-opposhop-out.wanyol.com/recycle';
    jsUrl = 'https://newucweb-ucnewtest.wanyol.com/resources/js/oppo.login.js';
  }
  /**
   * 发现过为空的情况，但还没找到重现方法
   * 2018-07-30
   */
  const urlObj = parse(window.location.href, true);
  const pid = urlObj.query.pid || '1384';
  const loginCallBack = window.location.origin + resolvedNextRoute.href;
  const openid = getOpenid();
  const oppocallback = `https://api.huishoubao.com/api/oauth/oppoCallBack?pid=${pid}&redirect_uri=${encodeURIComponent(loginCallBack)}`;
  if (openid) {
    try {
      const res = await loginByOppoOid(openid);
      if (res.success && res._data) {
        window.location.href = `${loginCallBack}&token=${res._data.token}`;
        return;
      }
      clearOpenid();
    } catch (err) {
      clearOpenid();
      // console.log(err);
    }
  }
  if (window !== window.top) {
    setTimeout(function () {
      window.parent.postMessage(JSON.stringify({
        evenId: 2,
        data: {
          callBack: oppocallback
        }
      }), oppoHost);
    }, 1000);
  } else {
    loadScript(jsUrl, function () {
      var h5Login = oppoHost + '?redirect=' + window.encodeURIComponent(oppocallback);
      window.oppo.win.open(h5Login);
      if (!toOppoLogin.loaded) {
        toOppoLogin.loaded = true;
        const colseOppoLogin = () => {
          window.oppo && window.oppo.win && window.oppo.win.closeWindow && window.oppo.win.closeWindow();
        };
        window.addEventListener('popstate', colseOppoLogin);
        window.addEventListener('unload', colseOppoLogin);
      }
    });
  }
};

export const toColaLogin = async function (resolvedNextRoute) {
  const urlObj = parse(window.location.href, true);
  const pid = urlObj.query.pid || '1439';
  const loginCallBack = window.location.origin + resolvedNextRoute.href;
  const openid = getOpenid();
  const colaCallback = `https://api.huishoubao.com/api/oauth/youpinCallBack?pid=${pid}&redirect_uri=${encodeURIComponent(loginCallBack)}`;
  const openColaLogin = () => {
    const loginUrl = `https://api.huishoubao.com/api/user/oauthLogin?redirectUri=${encodeURIComponent(loginCallBack)}&platform=5&pid=${pid}&oauthSite=youpin`;
    window.location.href = loginUrl;
  };
  if (openid) {
    window.location.href = `${colaCallback}&openId=${openid}`;
    return true;
  }
  openColaLogin();
};
